import React, { Component } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle, faRecycle, faSlash, faUserEdit, faExclamationCircle, faFileImport, faChainSlash } from "@fortawesome/free-solid-svg-icons";
import {Divider, Box,Text,Button,ButtonGroup,Center,Spacer,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton, Menu, MenuItem, MenuButton, MenuList} from '@chakra-ui/react';
import { ChevronDownIcon } from "@chakra-ui/icons";
import DataListGrid from "./ListGrid.jsx";
import ListDetailGrid from "./ListDetailGrid.jsx";
import {formatISO} from "date-fns";

import LookupEntityModal from "../../Observation/LookupEntityModal.jsx";
import CsvImportModal from "../../../components/Modals/CsvParserDialog.jsx";

import ConfigService from "../../../services/ConfigService.js";
import LocalStorageService from "../../../services/LocalStorageService.js";
import CoreService from "../../../services/CoreService.js";

import IdentityService from "../../../services/IdentityService.js";
import ServiceResponse from "../../../models/ServiceResponse.js";

import LookupEntityManager from "../../Observation/Components/Managers/LookupEntityManager.js";

import { ObservationSessionMode } from "../../../models/ObservationSessionMode.js";


const DelSwal = withReactContent(Swal);

export default class ListPanel extends Component 
{
  constructor(props) {
    super(props);



    this.configService = new ConfigService();
    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.state = {
      editMode: "add",
      listData: null,
      subListData: null,
      currentList: null,
      currentLookupEntityType: null,
      currentLookupEntity: null,
      currentSchemaId: null,
      isLoadingGrid: false,
      isModalOpen: false,
      modalErrMsg: "",
      isImportModalOpen: false,
      listName: '',
      description: '',
      modalData: [{ name: 'Big', id: 'Boy' }, { name: 'little', id: 'man' }],
      inModalSession: false,
      initialValueBag: [],
      sessionMode: ObservationSessionMode.NONE
    };

    this.refreshData = this.refreshData.bind(this);

    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onEntityRowSelectChange = this.onEntityRowSelectChange.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);
    this.onEditRequest = this.onEditRequest.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);
    this.onDeleteByEntityValueRequest = this.onDeleteByEntityValueRequest.bind(this);
    this.onImportRequest = this.onImportRequest.bind(this);
    this.closeImportModal = this.closeImportModal.bind(this);

    this.toInitialValueBag = this.toInitialValueBag.bind(this);


    this.onPostRequest = this.onPostRequest.bind(this);
    this.onPostImportRequest = this.onPostImportRequest.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.setSubListGrid = this.setSubListGrid.bind(this);



  }

  async componentDidMount() {
    await this.refreshData();
  }

  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var gridDataResponse = await this.coreService.fetchLookupEntityTypes(this.props.userSession.gcid, this.props.userSession.token);
    if (gridDataResponse.hasError) {
      this.props.onErrorPageRequest("Error fetching Lookup Entity Types.");
      return;
    }
    var allLists = gridDataResponse.dataResult;
    // supress system lists
    var systemLists = this.configService.getSystemEntities();
    var displayLists = allLists.filter(list => !systemLists.includes(list.entityType));

    console.log("List Data:");
    console.info(displayLists);
    this.setState({
      listData: displayLists,
      selectedRow: null, // reset
      isLoadingGrid: false,
      syncing: false
    });
  }

  onRowSelectChange(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    var newActiveStatus = newSelectedRow.enabled;

    this.setState({
      currentList: newSelectedRow,
      activeStatus: newActiveStatus,
      listName: newSelectedRow.entityType,
      currentLookupEntityType: newSelectedRow.entityType,
      modalErrMsg: ""
    }, () => {
      this.setSubListGrid()
    });

  }

  onEntityRowSelectChange(newSelectedRow)
  {
    console.log("OnRowSelectChange");
    console.log("set state for Entity selectedRow");
    console.info(newSelectedRow);
    var newActiveStatus = newSelectedRow.enabled;

    this.setState({
      currentLookupEntity: newSelectedRow,
      listName: newSelectedRow.entityType,
      modalErrMsg: ""
    });
  }


  async setSubListGrid() {
    if (this.state.currentList) 
    {
      // get lookup Entity Schemas for EACH schema represented
      var lookupSchemas = {};
      this.state.currentList.schemaIds.forEach(schemaId => 
      {
        var lookupEntitySchema = this.localStorageService.getSchema(schemaId);
        var lookupEntityCardSchema = LookupEntityManager.getLookupEntityCardSchema(lookupEntitySchema, this.state.currentList.entityType);
        lookupSchemas[schemaId] = lookupEntityCardSchema;
      });

      var gridDataResponse = await this.coreService.fetchLookupEntityByType(this.state.currentList.entityType, lookupSchemas, this.props.userSession.gcid, this.props.userSession.token);
      var newGridData = gridDataResponse.dataResult.map((d) => {
        return {id: d.metaData.id, entityKey: d.metaData.entityKey, entityType: d.metaData.entityType, schemaId: d.metaData.schemaId, identifier: d.metaData.identifier, description: d.metaData.entityType, lastUpdated: d.metaData.lastUpdated, lastUpdatedBy: d.metaData.lastUpdatedBy,
          data: d.data}});
      this.setState({
        subListData: newGridData
      });
    }
  }

  async onNewRequest(e, schemaId) {
    this.setState({
      editMode: "add",
      isModalOpen: true,
      inModalSession: true,
      currentSchemaId: schemaId,
      modalData: [],
      listName: "",
      description: "",
      modalErrMsg: "",
      initialValueBag: [],
      sessionMode: ObservationSessionMode.ADD
    });
  }

  onImportRequest()
  {
    this.setState({
      isImportModalOpen: true,
      inModalSession: false
    });
  }

  closeImportModal()
  {
    this.setState({isImportModalOpen: false});
  }


  onEditRequest() {
    if (!this.state.currentLookupEntity) {
      DelSwal.fire({ icon: "error", title: "Edit Lookup Entity", text: "Select an entity record first!" });
      return;
    }
    var initialValueBag = this.toInitialValueBag(this.state.currentLookupEntity);
    this.setState({
      editMode: "update",
      isModalOpen: true,
      inModalSession: true,
      currentSchemaId: this.state.currentLookupEntity.schemaId,
      initialValueBag: initialValueBag,
      sessionMode: ObservationSessionMode.COPY
    });
  }


  toInitialValueBag(lookupEntity)
  {
    var result = [];
    result.id = lookupEntity.id;
    result[lookupEntity.entityType] = lookupEntity.entityKey;
    lookupEntity.data.forEach((d) => {
      result[d.id] = d.value;
    })
    return result;
  }




  // #region Post Modal

  closeModal() {

    this.setState({
      isModalOpen: false,
      inModalSession: false
    })

  }



  async onPostRequest(lookupEntity)
  {
    var postResult = await this.coreService.postLookupEntity(lookupEntity, this.props.userSession.gcid, this.props.userSession.token);
    if (postResult.hasError)
    {
      this.props.onMsgBoxRequest("Lookup Entity Posting Problem", postResult.messages, null, "error");
      return;
    }
    var toastMsg = (this.state.sessionMode == ObservationSessionMode.ADD) ? "Lookup  " + lookupEntity.MetaData.EntityType + " " + lookupEntity.MetaData.EntityKey  + " has been created"
    : "Lookup  " + lookupEntity.MetaData.EntityType + " " + lookupEntity.MetaData.EntityKey + " has been updated."
    this.props.onToastRequest("information", toastMsg);
    await this.setSubListGrid();
    this.closeModal();

  }

  async onPostImportRequest(lookupEntityList)
  {
    var errCount = 0;
    var postCount = 0;
    for (var i=0; i<lookupEntityList.length; i++)
    {
      var lookupEntity = lookupEntityList[i];
      var postResult = await this.coreService.postLookupEntity(lookupEntity, this.props.userSession.gcid, this.props.userSession.token);
      if (postResult.hasError)
      {
        errCount = errCount + 1;
      }
      else 
      {
        postCount = postCount + 1;
      }
    }
    var toastMsg = "Posted " + postCount + " new lookup entities with " + errCount + " errors.";
    this.props.onToastRequest("information", toastMsg);
    await this.setSubListGrid();
    this.closeImportModal();
  }


  async onDeleteRequest() {
    if (!this.state.currentLookupEntity) {
      DelSwal.fire({ icon: "error", title: "Remove Entity", text: "Select a Lookup Entity to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove Entity?",
          text: "Confirm you want to permanently remove the existing list " + this.state.currentLookupEntity.entityKey + ". Note that this lookup entity value will no longer be available to inspectors in observations.",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.coreService.deleteLookupEntity(this.state.currentLookupEntity.id, this.props.userSession.gcid, this.props.userSession.token);
          await this.setSubListGrid();
          this.setState({ currentLookupEntity: null });
          return DelSwal.fire({ icon: "success", text:  "The Lookup Entity has been permanently deleted." });
        }
      }
      );
  }

  async onDeleteByEntityValueRequest() {
    if (!this.state.currentLookupEntity) {
      DelSwal.fire({ icon: "error", title: "Remove All Entities With Current Value", text: "Select a Lookup Entity to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove Entity?",
          text: "Confirm you want to permanently remove all entities with the current key value " + this.state.currentLookupEntity.entityKey + ". Note that this lookup entity value will no longer be available to inspectors in observations.",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.coreService.deleteLookupEntityByEntityKeyValue(this.state.currentLookupEntity.entityType, this.state.currentLookupEntity.entityKey, this.props.userSession.gcid, this.props.userSession.token);
          await this.setSubListGrid();
          this.setState({ currentLookupEntity: null });
          return DelSwal.fire({ icon: "success", text:  "The Lookup Entity has been permanently deleted." });
        }
      }
      );
  }


  // #endregion Post modal


  render() {
    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      <span/>
    );


    return (
      <Center id="admin-panel">


              <LookupEntityModal
                isOpen = {this.state.isModalOpen}
                userSession={this.props.userSession}
                schemaId={this.state.currentSchemaId}
                entityLookupKeyId={this.state.currentLookupEntityType}
                observationSessionMode={this.state.sessionMode}
                initialValueBag={this.state.initialValueBag}
                onToastRequest = {this.props.onToastRequest}
                onMsgBoxRequest = {this.props.onMsgBoxRequest}
                inModalSession = {this.state.inModalSession}
                onPostRequest = {this.onPostRequest}
                onCloseRequest = {this.closeModal}
              /> 

              <CsvImportModal
                isOpen = {this.state.isImportModalOpen}
                userSession={this.props.userSession}
                schemaId={this.state.currentLookupEntity?.schemaId ?? ""}
                entityLookupKeyId={this.state.currentLookupEntityType}
                observationSessionMode={this.state.sessionMode}
                onToastRequest = {this.props.onToastRequest}
                onMsgBoxRequest = {this.props.onMsgBoxRequest}
                inModalSession = {this.state.inModalSession}
                onPostRequest = {this.onPostImportRequest}
                onCloseRequest = {this.closeImportModal}

              />


        <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

          <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Lookup Entities</Text>
         


          <DataListGrid
            userSession={this.props.userSession}
            onToastRequest={this.props.onToastRequest}
            onErrorPageRequest={this.props.onErrorPageRequest}
            rowData={this.state.listData}
            onRowSelectChange={this.onRowSelectChange}
            //onEditRequest={this.onEditRequest}
          />

          { this.state.currentList &&

          <div>
            <Center margin='10px'>
            <ButtonGroup isAttached>

  

            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              >
              Add
              </MenuButton>

              <MenuList>
                {this.state.currentList.schemaIds.map((schemaId) => {
                  return  <MenuItem
                            id={"addbutton_" + schemaId}
                            onClick={(e) => this.onNewRequest(e, schemaId)}
                            icon={<FontAwesomeIcon icon={faPlusCircle} />}
                          >
                            {schemaId}
                          </MenuItem>
              })}
              </MenuList>
            </Menu>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faUserEdit} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={this.onEditRequest}
              >
                Edit
              </Button>

          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
              Delete
            </MenuButton>

            <MenuList>
              <MenuItem
                id="deletecurrentbutton"
                onClick={this.onDeleteRequest}
                icon={<FontAwesomeIcon icon={faSlash} />}
              >
                Delete Current
              </MenuItem>

              <MenuItem
                id="deleteentityvaluesbutton"
                onClick={this.onDeleteByEntityValueRequest}
                icon={<FontAwesomeIcon icon={faChainSlash} />}
              >
                Delete by Entity Value
              </MenuItem>            
            </MenuList>
          </Menu>









              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faFileImport} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={this.onImportRequest}
              >
                Import
              </Button>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faRecycle} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.setSubListGrid(e)}
              >
                Refresh
              </Button>
            </ButtonGroup>
            {loadingGridIcon}
            </Center>

            <ListDetailGrid
              userSession={this.props.userSession}
              onToastRequest={this.props.onToastRequest}
              onErrorPageRequest={this.props.onErrorPageRequest}
              currentList={this.state.currentList}
              subList={this.state.subListData}
              onRowSelectChange={this.onEntityRowSelectChange}
              onEditRequest={this.onEditRequest}
            />
          </div>

          }

        </Box>
      </Center>
    );
  }
}
